module.exports = __webpack_public_path__ + "img/logo1 (17).d7cef392.jpg";